import React from "react";
import "./Body.css";

import { Container, Row, Col } from "reactstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
library.add(faTimes, faCheck);

export default class Body extends React.Component {

  render() {
    return (
      <Container className="content-wrapper p-b-0">
        <Row className="top-banner">
          <Col md="6" className="left">
            <div>
              <p className="small-text">YOU ARE BUYING EVERY INTEGRATION AT LEAST TWICE</p>
              <h1>
                Are you in control of your integration landscape?
              </h1>
              <ul className="d-none d-sm-none d-md-block d-lg-block">
                <li>
                  <a className="int-btn blue-btn" href="#certificate-box-block">
                    Learn More
                  </a>
                </li>
                <li>
                  <a className="int-btn green-btn" href="/get-certified">get certified</a>
                </li>
              </ul>
            </div>
          </Col>
          <Col md="6" className="right">
            <img
              className="img-fluid d-block mx-auto"
              src={require("../../img/about-certified.png")}
              alt="Integrator"
            />
          </Col>
          <ul className="d-lg-none d-md-none d-sm-block d-xs-block">
            <li>
              <a className="int-btn blue-btn" href="#certificate-box-block">
                Learn More
              </a>
            </li>
            <li>
              <a className="int-btn green-btn" href="/get-certified">get certified</a>
            </li>
          </ul>
        </Row>
        <div className="under-banner">
          <h2 className="text-center">Avoid a messy integration landscape and lots of headaches. Make sure your suppliers are meeting the standards of todays integrations. Look for the Certified Integrator badge.</h2>
          <div className="logo-b">
            <img
              className="img-fluid mx-auto d-block"
              src={require("../../img/ci_badge_small.png")}
              alt="Integrator logo"
            />
          </div>
          <h3 className="text-center" id="certificate-box-block">Why use Certified Integrators?</h3>
        </div>
        <div className="row certificate-box-block">
          <Col md="6" className="certificate-box-left card">
            <Col className="card-body col">
              <h5 className="card-title">WITH CERTIFIED INTEGRATORS</h5>
              <ul>
                <li>
                  <FontAwesomeIcon className="oi" icon="check" />
                  Get in the front seat of your distributed API landscape with standards to ensure quality
                </li>
                <li>
                  <FontAwesomeIcon className="oi" icon="check" />
                  Confirmed knowledge of the ten essentials for an end-to-end integration
                </li>
                <li>
                  <FontAwesomeIcon className="oi" icon="check" />
                  Knowledge about the five essentials for a landscape of integrations
                </li>
                <li>
                  <FontAwesomeIcon className="oi" icon="check" />
                  Skill & experience assessed in certification examination, including case study
                </li>
              </ul>
            </Col>
          </Col>
          <Col md="6" className="certificate-box-right card">
            <Col className="card-body col">
              <h5 className="card-title">WITH NON-CERTIFIED INTEGRATORS</h5>
              <ul>
                <li>
                  <FontAwesomeIcon className="oi" icon="times" />
                  Risk of a messy integration landscape and lots of headaches
                </li>
                <li>
                  <FontAwesomeIcon className="oi" icon="times" />
                  Less re-use, leading to longer time-to-market and higher cost
                </li>
                <li>
                  <FontAwesomeIcon className="oi" icon="times" />
                  Unsecure integrations with risk of exposing sensitive
                  information
                </li>
                <li>
                  <FontAwesomeIcon className="oi" icon="times" />
                  Lack of usable documentation, results in slower onboarding of
                  integrations and APIs
                </li>
              </ul>
            </Col>
          </Col>
        </div>
        <Row className="control-structure-block p-t-90">

          <Col md="12" className=""><h3 className="text-center" id="certificate-box-block">You are buying every integration at least twice…</h3></Col>
          <Col md="3" className="align-items-center d-flex">
            <img
              className="img-fluid mx-auto d-block"
              src={require("../../img/control.png")}
              alt="Integrator logo"
            />
          </Col>
          <Col md="6" className="align-items-center d-flex justify-content-center">
            <p class="text-center grey-text">…GO FROM LACK OF LANDSCAPE CONTROL TO STRUCTURE, ORDER & REUSE</p>
            <img
              className="img-fluid arrow-right"
              src={require("../../img/arrow-right.png")}
              alt="Integrator logo"
            />
          </Col>
          <Col md="3" className="align-items-center d-flex">
            <img
              className="img-fluid mx-auto d-block"
              src={require("../../img/structure.png")}
              alt="Integrator logo"
            />
          </Col>
          <Col md="12">
            <h3 className="text-center p-t-90" id="certificate-box-block">There are only digital winners or digital losers…</h3>
          </Col>
          <Col md="3" className="align-items-center d-flex">
            <img
              className="img-fluid mx-auto d-block mw-150"
              src={require("../../img/man-sad.png")}
              alt="Integrator logo"
            />
          </Col>
          <Col md="6" className="align-items-center d-flex justify-content-center">
            <p class="text-center grey-text">…GO FROM DIGITAL LOSER TO DIGITAL WINNER BY FOLLOWING A STANDARD</p>
            <img
              className="img-fluid arrow-right"
              src={require("../../img/arrow-right.png")}
              alt="Integrator logo"
            />
          </Col>
          <Col md="3" className="align-items-center d-flex">
            <img
              className="img-fluid mx-auto d-block mw-150"
              src={require("../../img/man-happy.png")}
              alt="Integrator logo"
            />
          </Col>
        </Row>
      </Container>
    );
  }
}